export default {"src":"/_next/static/media/moonriver_native_coin.fdaf78e0.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};